<template>
    <div>
        <div class="mb-4 d-flex" v-for="(item,index) in messages" :class="item.user_type">
            <img  v-if="item.user_type=='admin'" :src="`${publicPath}/img/rcp/icon/cs-profile.png`" class="img-circle img-thumbnail p-0 avatar mr-2" alt="avatar">
            <div class="message w-75 fz-14" :class="item.user_type=='admin'?'mr-auto bg-upload-payment':'ml-auto'">
                <div v-if="item.info && getFileType(item.info.fileURL)=='image'">
                   <a :href="item.info.fileURL" target="_blank">
                        <img :src="item.info.fileURL"/>
                   </a>
                   <div>{{ getMessage(item.message,item.info.encodeURL) }}</div>
                </div>
                <div v-else-if="item.info && getFileType(item.info.fileURL)=='pdf'">
                    <a  :href="item.info.fileURL" target="_blank" class="d-flex align-items-center">
                        <img  :src="`${publicPath}/img/rcp/icon/file-download.png`" width="35px">
                        <div class="d-flex flex-column w-100 px-2">
                            <!-- <span class="fz-12 fw-500 text-grey3">{{ item.message.split(/(\\|\/)/g).pop() }}</span> -->
                            <span class="fz-12 fw-500 text-grey3">{{ getFileName(item.info.fileURL) }}</span>
                            <span class="fz-10 fw-500 text-grey4">{{ formatBytes(item.info.fileSize) }}</span>
                        </div>
                        <img  :src="`${publicPath}/img/rcp/icon/download2.png`" width="34px" class="ml-auto">
                    </a>
                    <div>{{ getMessage(item.message,item.info.encodeURL) }}</div>
                </div>
                <span v-else v-html="item.message"></span>
            </div>
            <img v-if="item.user_type=='member'" src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png" class="img-circle img-thumbnail p-0 avatar ml-2" alt="avatar">
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return{
            publicPath      :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            messages        :[]
        }
    },
    props:['list'],
    methods:{
        getFileName(url){
            let arr = url.split("/");
            return arr[arr.length-1];
        },
        getFileType(url){
            let indexImage = this.indexOfImage(url);
            let indexPDF = url.indexOf(".pdf");
            let type = '';

            if(indexImage !=-1){
                type = 'image';
            }
            else if(indexPDF != -1){
                type = 'pdf';
            }

            return type;  
        },
        indexOfImage(url){
            let index = url.indexOf(".png");
            index = (index == -1)?url.indexOf(".jpg"):index+4;
            index = (index == -1)?url.indexOf(".jpeg"):index+4;
            index = (index == -1)?url.indexOf(".gif"):index+5;
            
            return (index!=-1?index+4:index);
        },
        getMessage(str_message,encodeURL){
            let ret = str_message.replace(encodeURL,'');
            ret = ret.split(/(\\|\/)/g).pop();
            return ret;
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        }
    },
    mounted:function(){
        this.messages = this.list;
        // console.log("======================");
        // console.log(this.messages);
    }
}
</script>

<style scoped src="@/assets/css/chat.css"></style>
